export const AUTHENTICATION_LOGGING_PROGRESS = "AUTHENTICATION_LOGGING_PROGRESS";
export const AUTHENTICATION_LOGGED_IN = "AUTHENTICATION_LOGGED_IN";
export const AUTHENTICATION_LOGGED_OUT = "AUTHENTICATION_LOGGED_OUT";
export const AUTHENTICATION_LOGGING_ERROR = "AUTHENTICATION_LOGGING_ERROR";

export const AUTHENTICATION_PROGRESS = "AUTHENTICATION_AUTHENTICATION_PROGRESS";
export const AUTHENTICATION_SUCCESS = "AUTHENTICATION_AUTHENTICATION_SUCCESS";
export const AUTHENTICATION_ERROR = "AUTHENTICATION_AUTHENTICATION_ERROR";
export const AUTHENTICATION_SELECT = "AUTHENTICATION_AUTHENTICATION_SELECT";
export const AUTHENTICATION_CLEAR = "AUTHENTICATION_CLEAR";

export const AUTHENTICATION_ENVIRONMENT_PROGRESS = "AUTHENTICATION_ENVIRONMENT_PROGRESS";
export const AUTHENTICATION_ENVIRONMENT_SUCCESS = "AUTHENTICATION_ENVIRONMENT_SUCCESS";
export const AUTHENTICATION_ENVIRONMENT_ERROR = "AUTHENTICATION_ENVIRONMENT_ERROR";
export const AUTHENTICATION_ENVIRONMENT_SELECT = "AUTHENTICATION_ENVIRONMENT_SELECT";
export const AUTHENTICATION_ENVIRONMENT_SET_BASE_SERVER = "AUTHENTICATION_ENVIRONMENT_SET_BASE_SERVER";
export const AUTHENTICATION_ENVIRONMENT_CLEAR = "AUTHENTICATION_ENVIRONMENT_CLEAR";

export const AUTHENTICATION_CLEAR_ERROR_MESSAGE = "AUTHENTICATION_CLEAR_ERROR_MESSAGE";
